import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ProcessorDetails } from '@/lib/api/processors';
import { ProcessorHeader } from '../components/processor-header';
import { ProcessorOverviewCard } from '../components/processor-overview-card';
import { ProcessorMetricsCard } from '../components/processor-metrics-card';
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card';

interface Props {
  processor: ProcessorDetails;
}

const OnyxConfigurationCard = ({ processor }: Props) => {
  const options = processor.options as Record<string, unknown> | null;
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle>Onyx Processing Configuration</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <p className="text-sm text-muted-foreground">Secret Key</p>
            <p className="font-mono text-sm">••••••••••••••••</p>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Environment</p>
            <Badge variant={options?.testMode ? 'outline' : 'default'}>
              {options?.testMode ? 'Test' : 'Live'}
            </Badge>
          </div>
          <div>
            <p className="text-sm text-muted-foreground">Supported Countries</p>
            <p className="text-sm">United States, Canada</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const OnyxProcessorDetailsPage = ({ processor }: Props) => (
  <>
    <ProcessorHeader type="onyx" processor={processor} />
    <ProcessorOverviewCard processor={processor} />
    <ProcessorMetricsCard processor={processor} />
    <OnyxConfigurationCard processor={processor} />
    <ProcessorPaymentMethodsCard processor={processor} />
  </>
);
